export class Product {
    productId: number;
    isStockPresent:boolean;
    productDescTitle: string;
    shortDescription: string;
    mainDescription: string;
    type: string;
    subCatId: number;
    catId: number;
    pname: string;
    sku: string;
    subCatName: string;
    discountPrice: number;
    imageName: string;
    mrp: number;
    unitId: number;
    discount: number;
    slug: string;
    pageTitle: string;
    stockQuantity: number;
    quantity: number;
    metaDescription: string;
    netWeight: number;
    pdescription: string;
    detailDescription: string;
    productVideoThumbnailName: string;
    videoThumbnailAltText: string;
    productVideoName: string;
    unitName: string;
    proImageList: ProImageList[];
    skuId: number;
    imagesArray: ImageArrayList[];
    activeStatus: boolean;
    isBestSellerProduct: boolean;
}

export class ProImageList {

    pimgId: number;
    productId: number;
    imageOrder: number;
    imageName: string;
    activeStatus: boolean;
    createdDate: string;
    createdBy: number;
    updatedDate: string;
    updatedBy: number;

}
export class ImageArrayList {
    imageName: string;
    order: number;
    imageId: number;
    altText: string;
    isVideo: boolean;
    thumnailName: string;
}

export class ProductList {
    productId: number;
    productName: string;
    sku: string;
    subCatName: string;
    subCatId: number;
    imageName: string;
    activeStatus: boolean;
    mrp: number;
}

export class ProductName {
    pname: string;
    productId: number;
}

export class ProductType {
    subCatName: string;
    catId: number;
    subCatId: number;
    catName: string;
    [key: string]: any
}

export class AddProduct {
    ProductImageId: number;
    ImageName: string;
}